const cardHolderPresOptions = [
  {
    "key": "CUSTOMER_PRESENT",
    "text": "Customer present"
  },
  {
    "key": "CUSTOMER_NOT_PRESENT",
    "text": "Customer not present"
  },
  {
    "key": "MAIL_ORDER",
    "text": "Mail order"
  },
  {
    "key": "TELEPHONE_ORDER",
    "text": "Telephone order"
  },
  {
    "key": "RECURRING_PAYMENT",
    "text": "Recurring payment"
  },
  {
    "key": "PRE_AUTHORIZED_PURCHASE",
    "text": "Pre authorized purchase"
  },
  {
    "key": "DEFERRED_BILLING",
    "text": "Deferred billing"
  },
  {
    "key": "INSTALLMENT_PAYMENT",
    "text": "Installment payment"
  }
]

export default cardHolderPresOptions;
